var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", [
      _vm._v(
        _vm._s(
          _vm.$t("notification.tableWidgetUpdated", {
            actor: _vm.$_.get(_vm.activity, "actorUser.name"),
            tableName: _vm.$_.get(_vm.activity, "payload.tableName"),
            pageName: _vm.$_.get(_vm.activity, "payload.pageName"),
            widgetTitle: _vm.$_.get(_vm.activity, "payload.widgetTitle"),
            widgetType: _vm.$_.get(_vm.activity, "payload.widgetType"),
          })
        )
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }